import { useQuery } from "@tanstack/react-query";
import apiClient from "@/apis/client";
import type { ICategory } from "./types";

/**
 * 도메인별 카테고리 조회 응답 인터페이스
 */
interface IGetCategoriesByDomainResponse {
  success: boolean;
  message: string;
  data: ICategory[];
}

/**
 * 도메인별 카테고리 조회 API 함수
 */
const getCategoriesByDomain = async (
  domainId: string
): Promise<IGetCategoriesByDomainResponse> => {
  const response = await apiClient.get<IGetCategoriesByDomainResponse>(
    `/categories/domain/${domainId}`
  );
  return response.data;
};

/**
 * 도메인별 카테고리 조회 훅
 */
export const useQueryGetCategoriesByDomain = (domainId: string) => {
  return useQuery({
    queryKey: ["categories", "domain", domainId],
    queryFn: () => getCategoriesByDomain(domainId),
    enabled: !!domainId,
  });
};
